import { useEffect, useState } from 'react'
import { pobierzZwykleCeny, zapytanieZwyklychCen } from '../api/zwykleCeny'

/**
 * Zwykłe ceny dla parametrów (`api/zwykleCeny`), z opóźnieniem: przy polach wpisywanych na bieżąco (rachunek,
 * budżet) każda cyfra byłaby osobnym zapytaniem. Poprzednie zapytanie anulujemy przy zmianie parametrów.
 * Zwraca `{ dane, laduje }`; `dane` null, gdy widełek nie ma albo endpoint nie odpowiada.
 */
const useZwykleCeny = (parametry, { opoznienie = 400 } = {}) => {
  const klucz = parametry ? zapytanieZwyklychCen(parametry) : null
  const [stan, setStan] = useState({ dane: null, laduje: Boolean(klucz) })

  useEffect(() => {
    if (!klucz) { setStan({ dane: null, laduje: false }); return undefined }
    const kontroler = new AbortController()
    setStan((s) => ({ ...s, laduje: true }))
    const t = setTimeout(() => {
      pobierzZwykleCeny(Object.fromEntries(new URLSearchParams(klucz)), { signal: kontroler.signal }).then((dane) => {
        if (!kontroler.signal.aborted) setStan({ dane, laduje: false })
      })
    }, opoznienie)
    return () => { clearTimeout(t); kontroler.abort() }
  }, [klucz, opoznienie])

  return stan
}

export default useZwykleCeny
